// TODO: move this file into dedicated `contexts` folder inside `plugins`

import React, { Dispatch, SetStateAction, useCallback, useContext, useEffect, useState } from 'react'

import { PluginsAPI } from '@makyoapp/makyo-sdk'
import { Order } from '@makyoapp/makyo-sdk/api/api'
import { PluginOrderBy } from '@makyoapp/makyo-sdk/models/Plugins'
import { PluginAdapter } from '@makyoapp/makyo-common'

import { fromSdkPluginList } from '@/adapters/PluginAdapter'

export type PricingScheme = 'free' | 'premium' | 'all'
export type BuildByScheme = 'makyo' | '3rd-party' | 'all'

export interface PluginFilterState {
  categories: string[]
  types: string[]
  pricing: PricingScheme
  setPricing: (scheme: PricingScheme) => void
  setTypes: (types: string[]) => void
  setCategories: (categories: string[]) => void
  plugins: PluginAdapter[]
  favorites: string[]
  setFavorites: Dispatch<SetStateAction<string[]>>
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
}

/**
 * initial plugin state
 */
export const initialPluginFilterState: PluginFilterState = {
  categories: [],
  types: [],
  pricing: 'all',
  setPricing: () => null,
  setTypes: () => null,
  setCategories: () => null,
  plugins: [],
  favorites: [],
  setFavorites: () => null,
  isLoading: false,
  setIsLoading: () => null,
}

const PluginFilterContext = React.createContext(initialPluginFilterState)

/**
 * use app context hook
 */
export function usePluginFilterContext() {
  return useContext(PluginFilterContext)
}

export default function PluginFilterProvider({ children }: { children: React.ReactNode }) {
  // local state
  const [plugins, setPlugins] = useState<PluginAdapter[]>([])
  const [isLoading, setIsLoading] = useState(initialPluginFilterState.isLoading)
  const [favorites, setFavorites] = useState<string[]>([])

  // filter state
  const [categories, setCategories] = useState(initialPluginFilterState.categories)
  const [types, setTypes] = useState(initialPluginFilterState.types)
  const [pricing, setPricing] = useState(initialPluginFilterState.pricing)

  const handleList = useCallback((page: number) => {
    setIsLoading(true)

    PluginsAPI.ReqList(page, undefined, Order.Desc, PluginOrderBy.CreatedAt)
      .then((res) => {
        const results = fromSdkPluginList(res._Data)
        setPlugins(results)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  useEffect(() => {
    handleList(1)
  }, [setPlugins, handleList])

  return (
    <PluginFilterContext.Provider
      value={{
        categories,
        setCategories,
        types,
        setTypes,
        pricing,
        setPricing,
        plugins,
        favorites,
        setFavorites,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </PluginFilterContext.Provider>
  )
}
